class SizeGuideModal {
    constructor() {
        this.modal = document.getElementById('SizeGuideModal');
        this.content = document.getElementById('SizeGuideContent');
        this.closeBtn = this.modal?.querySelector('.size-guide-modal__close');
        this.overlay = this.modal?.querySelector('.size-guide-modal__overlay');
        this.cachedContent = null;

        this.init();
    }

    init() {
        const triggers = document.querySelectorAll('[data-size-guide-trigger]');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });

        this.closeBtn?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal?.classList.contains('active')) {
                this.close();
            }
        });
    }

    async open() {
        this.modal?.classList.add('active');
        document.body.style.overflow = 'hidden';

        if (!this.cachedContent) {
            try {
                const response = await fetch('/pages/size-guides');
                const html = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const mainContent = doc.querySelector('.policy-container');

                if (mainContent) {
                    // Remove the main heading if it exists as we have a title in modal
                    const heading = mainContent.querySelector('.policy-heading');
                    if (heading) heading.remove();

                    this.cachedContent = mainContent.innerHTML;
                    this.content.innerHTML = this.cachedContent;
                } else {
                    this.content.innerHTML = '<p style="text-align:center;">Size guide content not found.</p>';
                }
            } catch (error) {
                console.error('Error fetching size guide:', error);
                this.content.innerHTML = '<p style="text-align:center;">Failed to load size guide.</p>';
            }
        } else {
            this.content.innerHTML = this.cachedContent;
        }
    }

    close() {
        this.modal?.classList.remove('active');
        document.body.style.overflow = '';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new SizeGuideModal();
});
